import { render } from "./WorkspaceDetailPage.vue?vue&type=template&id=9b53e6ca&scoped=true"
import script from "./WorkspaceDetailPage.vue?vue&type=script&lang=js"
export * from "./WorkspaceDetailPage.vue?vue&type=script&lang=js"

import "./WorkspaceDetailPage.vue?vue&type=style&index=0&id=9b53e6ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b53e6ca"]])

export default __exports__